var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgerydetailsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 1.875H3.125C2.79348 1.875 2.47554 2.0067 2.24112 2.24112C2.0067 2.47554 1.875 2.79348 1.875 3.125V11.875C1.875 12.2065 2.0067 12.5245 2.24112 12.7589C2.47554 12.9933 2.79348 13.125 3.125 13.125H11.875C12.2065 13.125 12.5245 12.9933 12.7589 12.7589C12.9933 12.5245 13.125 12.2065 13.125 11.875V3.125C13.125 2.79348 12.9933 2.47554 12.7589 2.24112C12.5245 2.0067 12.2065 1.875 11.875 1.875ZM7.5 3.75C8.70625 3.75 9.6875 4.73125 9.6875 5.9375C9.6875 7.14375 8.70625 8.125 7.5 8.125C6.29375 8.125 5.3125 7.14375 5.3125 5.9375C5.3125 4.73125 6.29375 3.75 7.5 3.75Z",
    fill: "#0D6B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgerydetailsicon);
export default __webpack_public_path__ + "static/media/surgerydetailsicon.67d003f6f35ce6548b957b61bf1c4371.svg";
export { ForwardRef as ReactComponent };